module.exports = __webpack_public_path__ + "static/media/lunchMenu.452d4773.pdf";